'use strict';

var React = require('react');
var VerticalScrollBar = require('../common/VerticalScrollBar');
var styleHelper = require('../../helper/styleHelper');
var propConst = require('../../constants/propConst');

var VerticalScrollBarCom = React.createClass({

  render: function () {
    var v = styleHelper.getInt(this.props,propConst.PROGRESS);
    return (<VerticalScrollBar
      backgroundColor={'#fff'}
      value={v}
    />);
  }
});

module.exports = VerticalScrollBarCom;



// WEBPACK FOOTER //
// ./src/views/Components/VerticalScrollBarCom.jsx